import { useSelector } from "react-redux";

const useViewMode = ({
  isAllManage = false,
  isTeamManage = false,
  permission,
  isEntityLocked = false,
  ownerId,
  checkOwner = true,
}) => {
  const currentUser = useSelector(state => state?.owner?.currentuser);
  const currentUserId = currentUser?.userId;
  const myTeam = useSelector(state => state?.owner?.Team);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);

  const canEdit = !!permission;

  // Determine which list to check against
  const applicableList = isAllManage ? ownerlist : isTeamManage ? myTeam : [];

  const isSameOwner = currentUserId === ownerId;
  const isInScope = !!applicableList?.find(item => item?.id === ownerId); // ← explicit boolean

  // If checkOwner is false, skip ownership check entirely
  const hasOwnerAccess = !checkOwner || isSameOwner || isInScope;

  const isViewMode = !canEdit || isEntityLocked || !hasOwnerAccess;

  return { isViewMode, canEdit, isSameOwner, isInScope, hasOwnerAccess };
};

export default useViewMode;